import "./headersub.css";
import React, { useState } from "react";
import {
  MDBContainer,
  MDBNavbar,
  MDBNavbarBrand,
  MDBNavbarToggler,
  MDBIcon,
  MDBNavbarNav,
  MDBBtn,
  MDBDropdown,
  MDBDropdownToggle,
  MDBDropdownMenu,
  MDBDropdownItem,
  MDBCollapse,
} from "mdb-react-ui-kit";
import { Link } from "react-router-dom";
import { useCookies } from "react-cookie";
import { useLayoutEffect } from "react";
import Login from "../../compo/Login/Login";

export default function App() {
  const [showBasic, setShowBasic] = useState(false);
  const [displayLogin, setDisplayLogin] = useState("none");
  const [isLogin, setisLogin] = useState(false);
  const [cookies, setCookie, removeCookie] = useCookies([]);

  useLayoutEffect(()=>{
    // console.log(cookies.login);
    if(cookies.login){
      setisLogin(true)
      console.log("header lay called");
    }
  },[])

  function noneLoginModel() {
    setDisplayLogin("none");
  }

  const LogoutFun = () => {
    setisLogin(false);
    removeCookie("userid");
    removeCookie("username");
    removeCookie("login");
    // setCookie('login', false);
    console.log(cookies);
  };

  return (
    <MDBNavbar expand="lg" className="bg-sub">
      <MDBContainer className="p-0 pt-3">
        <Link to="/" className="navbar-brand pt-0">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="115"
            height="35"
            viewBox="0 0 115 35"
          >
            <defs>
              <radialGradient
                id="prefix__a"
                cx="98.305%"
                cy="99.794%"
                r="263.393%"
                fx="98.305%"
                fy="99.794%"
                gradientTransform="matrix(.36145 0 0 1 .628 0)"
              >
                <stop offset="1%" stop-color="#FFF" />
                <stop offset="4%" stop-color="#C6FFFF" />
                <stop offset="9%" stop-color="#80FFFF" />
                <stop offset="13%" stop-color="#49FFFF" />
                <stop offset="17%" stop-color="#21FFFF" />
                <stop offset="20%" stop-color="#09FFFF" />
                <stop offset="22%" stop-color="#0FF" />
                <stop offset="28%" stop-color="#01F6FF" stop-opacity=".96" />
                <stop offset="39%" stop-color="#04DEFF" stop-opacity=".87" />
                <stop offset="53%" stop-color="#08B6FF" stop-opacity=".71" />
                <stop offset="69%" stop-color="#0E7FFF" stop-opacity=".5" />
                <stop offset="87%" stop-color="#1639FF" stop-opacity=".22" />
                <stop offset="100%" stop-color="#1C00FF" stop-opacity="0" />
              </radialGradient>
            </defs>
            <g fill="none" fill-rule="evenodd">
              <g fill-rule="nonzero">
                <path
                  fill="#FFF"
                  d="M27.043 21.869l.07.01c.537.07 1.064.169 1.468.351.374.165.593.374.793.745.304.561.324 1.353.049 1.95-.205.445-.656.818-1.068 1.016-.42.196-.87.318-1.332.36-.864.083-1.736-.072-2.518-.45-.45-.218-1-.596-1.276-1.082-.21-.363-.19-.815.05-1.158.396-.54 1.241-.658 1.88-.636.486.019 1.36.17 1.822.333.128.046.6.228.682.313.063.056.09.141.07.222-.105.322-.889.491-1.115.526-.606.092-.92-.136-1.61-.408-.183-.076-.375-.129-.572-.157-.312-.03-.69.057-.75.398-.03.176.177.34.334.409.325.145.677.22 1.034.22 1.073.018 2.281-.159 3.159-.78.12-.085.239-.21.24-.369.003-.319-.557-.514-.557-.514-.592-.246-1.689-.366-2.251-.412-.591-.051-1.521-.128-1.745-.16-.233-.026-.461-.082-.679-.168-.218-.1-.383-.287-.454-.515-.102-.403.03-.897.253-1.218.587-.842 1.962-1.162 2.989-1.289.995-.123 2.603-.122 3.579.396.15.08.228.156.196.316-.064.302-.291.497-.567.582-.29.092-.887.128-1.15.144-1.177.066-2.603.031-3.722.337-.088.025-.24.065-.289.12-.175.19.326.244.433.267.024.006.047.01.07.012l2.48.291.004-.002zm-7.005-5.236s.192-.287.352-.503c.364-.467.772-.898 1.22-1.286.121-.103.265-.22.265-.22s-.225.022-.352.048c-.301.059-.745.35-.966.542-.365.312-.766.82-.585 1.27.026.064.067.149.067.149zm2.03.542c.57-.04 1.122-.205 1.619-.484.492-.275 1.22-.812 1.144-1.444-.022-.192-.147-.357-.327-.43-.22-.096-.334-.08-.615 0-.172.045-.337.114-.49.206-.566.328-1.368 1.03-1.804 1.59-.1.133-.202.282-.281.382-.05.062-.09.12-.085.135.017.064.612.057.838.042l.002.003zM20.6 18.252c-.06.062-.123.214-.188.323-.037.063-.085.118-.14.165-.151.11-.278.115-.423-.012-.203-.188-.322-.45-.33-.727-.003-.118.017-.247-.005-.35-.037-.168-.206-.34-.296-.501-.115-.227-.185-.474-.205-.728-.037-.662.313-1.273.768-1.754.484-.502 1.065-.9 1.71-1.167.616-.26 1.519-.435 2.195-.202.262.094.496.252.682.459.025.04.056.075.093.105.055.02.113.034.171.04.238.054.46.16.654.308.254.219.394.429.458.733.13.613-.223 1.285-.626 1.694-.69.702-1.37 1.2-2.25 1.544-.388.15-.992.292-1.431.252-.137-.012-.277-.047-.41-.056-.117-.019-.233-.048-.344-.089-.033-.025-.075-.048-.083-.039v.002zm.786 1.356c.036.008.07.018.104.03.31.118.437.403.513.717.177.728.252 2.34.282 2.97.021.473.033.94.053 1.407.016.396.049.923-.034 1.294-.033.15-.122.282-.248.369-.147.093-.481.101-.665.063-.453-.094-.6-.384-.665-.83-.153-1.067-.08-3.158.012-4.042.03-.291.14-1.226.292-1.614.052-.133.164-.399.357-.36v-.004zM7.612 21.382s-.674.048-1.138.099c-.59.064-1.7.255-2.339.483-.192.07-.582.23-.616.428-.035.197.091.363.233.529.081.095.544.539.674.647.543.453 1.644 1.15 2.456 1.49.281.114.74.28.74.28s-.035-1.31-.028-2.597c0-.68.018-1.354.018-1.354v-.005zm12.357.521c.038.351-.052 1.018-.07 1.105-.049.247-.116.49-.201.726-.112.256-.237.505-.374.748-.292.477-.648.913-1.058 1.295-1.16 1-2.955 1.57-4.497 1.754-1.118.134-2.249.104-3.357-.09-.382-.07-.949-.2-.949-.2s0 .227-.016.386c-.02.111-.052.22-.095.325-.076.16-.229.268-.404.289-.232.043-.479.057-.693-.035-.352-.147-.479-.476-.54-.854-.05-.304-.102-.83-.102-.83s-.263-.126-.482-.234c-.658-.327-1.286-.71-1.877-1.147-.154-.116-.822-.673-.969-.811-.416-.395-.785-.784-1.068-1.283-.22-.39-.281-.737-.116-1.15.23-.575 1.059-1.01 1.625-1.256.416-.184 1.709-.605 2.246-.683.254-.037.648-.107.671-.122.01-.007.017-.014.024-.023.013-.017.033-.587.03-.795-.005-.209.152-1.553.203-1.838.026-.153.14-.747.262-.902.078-.105.217-.097.33-.028.615.382.802 1.708.848 2.382.027.412.041 1.03.041 1.03s.704-.022 1.141-.01c.445.02.888.07 1.327.147.563.089 1.655.327 2.283.645.517.26 1 .701 1.157 1.167.146.428.124.723-.098 1.11-.249.434-.72.758-1.2.785-.14.008-.677-.063-.843-.19-.06-.053-.067-.143-.015-.204.134-.085.273-.162.416-.232.07-.038.134-.084.193-.137.123-.108.234-.226.221-.366-.017-.18-.211-.292-.391-.363-.857-.34-2.568-.622-3.395-.67-.323-.02-.784-.036-.784-.036l.098 4.554s.38.07.68.122c.172.026.901.09 1.095.096 1.478.04 3.122-.093 4.476-.73.595-.281 1.14-.627 1.553-1.097.56-.654.833-1.507.754-2.364-.083-.972-.769-2.125-1.316-2.827-1.446-1.856-3.925-3.382-6.106-4.276-2.227-.913-4.428-1.439-6.79-1.527-.61-.022-1.938.009-2.61.194-.095.027-.192.059-.28.08-.075.018-.146.048-.212.087-.012.01-.023.02-.033.032.026.015.053.028.081.04.07.03.37.05.526.077.14.027.28.1.34.201.058.102.06.172-.004.252-.152.185-.725.154-.977.114-.253-.04-.589-.122-.648-.351-.07-.268.057-.531.195-.772.277-.486.674-.74 1.256-.898.865-.23 1.752-.369 2.647-.414 1.764-.07 3.433.241 5.143.759 1.093.339 2.161.753 3.197 1.24.799.395 1.576.832 2.328 1.309.188.123 1.287.928 1.458 1.07.356.29.821.708 1.158 1.042.653.645 1.465 1.634 1.86 2.42.095.187.168.372.29.59.099.21.183.428.252.65.03.128.074.315.08.322.009.07.095.453.085.6zm22.179-1.007c-.827.19-3 .296-3 .296l-.273.856s1.086-.093 1.876-.01c0 0 .256-.03.285.29.005.205-.003.412-.025.617 0 0-.016.194-.291.243-.298.05-2.34.128-2.34.128l-.33 1.116s-.124.258.152.185c.256-.07 2.395-.47 2.673-.412.299.074.63.471.534.833-.114.45-2.252 1.808-3.551 1.713 0 0-.683.044-1.26-.876-.539-.877.203-2.537.203-2.537s-.34-.776-.093-1.038c0 0 .146-.133.574-.163l.525-1.083s-.597.04-.952-.397c-.33-.415-.358-.606-.104-.72.27-.134 2.754-.586 4.463-.529 0 0 .593-.058 1.108.97 0 0 .25.416-.174.515v.003zM35.72 25.05c-.22.514-.797 1.063-1.516.722-.72-.341-1.84-2.649-1.84-2.649s-.428-.86-.511-.838c0 0-.093-.168-.15.772-.057.94.012 2.762-.363 3.049-.351.288-.783.173-1.006-.163-.202-.332-.287-1.123-.176-2.503.13-1.387.452-2.862.865-3.321.413-.46.742-.126.871-.005 0 0 .552.498 1.46 1.96l.16.272s.826 1.381.915 1.379c0 0 .067.063.127.017.087-.024.052-.468.052-.468s-.171-1.506-.925-4.056c-.066-.198-.079-.41-.036-.615.076-.301.379-.16.379-.16s1.167.585 1.733 2.481c.566 1.897.185 3.609-.037 4.126h-.002zm12.566-1.135c-.532.925-2.033 2.862-4.027 2.404-.658 1.593-1.21 3.205-1.528 5.615 0 0-.07.468-.46.306-.386-.136-1.023-.777-1.153-1.665-.14-1.166.382-3.137 1.446-5.397-.31-.503-.522-1.222-.341-2.246 0 0 .267-1.9 2.18-3.613 0 0 .23-.198.363-.137.146.062.078.68-.038.983-.116.303-.972 1.77-.972 1.77s-.53.994-.382 1.777c1.004-1.538 3.285-4.643 4.698-3.663.475.338.694 1.076.695 1.87 0 .698-.17 1.44-.48 1.996h-.001zm-.413-2.44s-.08-.611-.679.063c-.515.568-1.445 1.634-2.194 3.081.785-.087 1.544-.513 1.772-.73.373-.33 1.24-1.224 1.1-2.414zm11.396-.14h-3.654c-.072-1.239-.225-2.47-.458-3.69-.024-.128-.137-.221-.268-.221h-.844c-.074 0-.144.034-.19.09-.048.058-.067.133-.053.205.238 1.194.394 2.402.466 3.617h-3.517c-.079 0-.155.03-.21.086-.056.055-.087.13-.087.21v.756c0 .079.03.155.086.21.056.056.132.087.21.087h3.567c0 .188.004.355.004.513.006 1.005-.045 2.01-.153 3.01-.007.078.019.155.07.212.052.058.126.092.204.094h.781c.153 0 .28-.115.295-.266.106-1.012.157-2.03.152-3.047 0-.157 0-.325-.004-.512h3.604c.079 0 .154-.032.21-.087.056-.056.087-.131.087-.21v-.757c0-.08-.032-.155-.087-.21-.056-.056-.132-.087-.21-.087v-.003z"
                  transform="translate(2 1.313)"
                />
                <path
                  fill="url(#prefix__a)"
                  d="M54.662 15.646C51.15 7.033 43.152 1.061 33.879.127 24.605-.807 15.573 3.45 10.406 11.188c-.052.076-.065.172-.034.26.03.086.098.155.185.184l.655.22c.038.013.078.02.118.02.121 0 .235-.06.302-.161 4.435-6.52 11.82-10.425 19.72-10.422C40.93 1.29 49.577 7.01 53.31 15.81c.054.127.179.21.317.21h.782c.09 0 .175-.045.226-.12.05-.075.06-.17.027-.254z"
                  transform="translate(2 1.313)"
                />
              </g>
              <path
                fill="#FFF"
                d="M101.553 17.892c1.222 0 2.248.453 2.897 1.403h.03v-1.177h1.569v8.358h-1.57V25.18h-.03c-.587.995-1.644 1.509-2.835 1.509-2.444 0-4.436-1.841-4.436-4.255 0-2.67 1.916-4.541 4.375-4.541zm-24.945 0c2.308 0 4.48 1.81 4.45 4.466-.03 2.276-1.974 4.411-4.728 4.327-2.335-.071-4.32-2.078-4.293-4.414.03-2.521 2.025-4.379 4.571-4.379zm12.643 0c1.388 0 2.52.966 2.565 2.444h-1.57c-.075-.603-.421-1.01-1.07-1.01-.604 0-.98.407-.98.89 0 .708.724.92 1.553 1.176 1.177.362 2.263 1.071 2.263 2.625 0 1.614-1.177 2.67-2.806 2.67-1.509 0-2.957-1.025-2.957-2.957h1.57c.075 1.012.587 1.524 1.417 1.524.724 0 1.207-.467 1.207-1.146 0-.574-.437-.95-1.418-1.268-2.052-.648-2.399-1.538-2.399-2.489 0-1.478 1.252-2.459 2.625-2.459zm-26.08-2.58c.867 0 1.57.703 1.57 1.57v2.127h.03c.498-.74 1.297-1.117 2.338-1.117 1.992 0 3.485 1.267 3.485 3.56v5.024h-1.569v-4.54c0-1.796-.694-2.61-2.081-2.61-1.373 0-2.203.995-2.203 2.625v4.525h-1.57V15.313zm21.237 0v2.806h1.373v1.434h-1.373v6.924c-.866 0-1.569-.702-1.569-1.569v-5.355h-.648v-1.434h.648v-2.805h1.57zm10.9 0v2.806h1.372v1.434h-1.373v6.924c-.866 0-1.569-.702-1.569-1.569v-5.355h-.648v-1.434h.648v-2.805h1.57zm16.384 2.58v1.615c-1.358.045-2.052.874-2.052 2.277v3.123c0 .867-.702 1.57-1.569 1.57v-8.359h1.463v.755h.03c.378-.558 1.026-.92 2.128-.98zm-35.16 1.433c-1.798 0-3.32 1.746-2.835 3.691.33 1.319 1.532 2.274 2.891 2.237 1.605-.044 2.902-1.326 2.902-2.986 0-1.63-1.313-2.942-2.957-2.942zm25.067 0c-1.657 0-2.994 1.496-2.84 3.264.127 1.457 1.318 2.635 2.78 2.664 1.658.034 2.971-1.337 2.971-2.94 0-1.63-1.177-2.988-2.911-2.988z"
                transform="translate(2 1.313)"
              />
            </g>
          </svg>
        </Link>

        <MDBNavbarToggler
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
          onClick={() => setShowBasic(!showBasic)}
        >
          <MDBIcon icon="bars" fas />
        </MDBNavbarToggler>

        <MDBCollapse navbar show={showBasic}>
          <MDBNavbarNav className="mr-auto mb-2 mb-lg-0">
            <img src="./disney-hotstar-logo-dark" alt="" />
          </MDBNavbarNav>
          <MDBDropdown>
            <MDBDropdownToggle
              tag="a"
              className="nav-link bord text-white me-4 dropdown-sub-header-lang"
              role="button"
            >
              <span>View in </span>English
            </MDBDropdownToggle>
            <MDBDropdownMenu className="bg-tr">
              <MDBDropdownItem link className="bg-tr-a">
                हिंदी
              </MDBDropdownItem>
              <MDBDropdownItem link className="bg-tr-a">
                தமிழ்
              </MDBDropdownItem>
              <MDBDropdownItem link className="bg-tr-a">
                తెలుగు
              </MDBDropdownItem>
            </MDBDropdownMenu>
          </MDBDropdown>
          {!isLogin ? (
            <div
              className="btn bg-primary text-white"
              onClick={() => setDisplayLogin("flex")}
            >
              Login
            </div>
          ) : (
            <div class="dropdown right-element user-profile ms-3 ">
              <a
                class="dropdown-toggle d-flex align-items-center hidden-arrow"
                href="#"
                id="navbarDropdownMenuAvatar"
                role="button"
                data-mdb-toggle="dropdown"
                aria-expanded="false"
              >
                <img
                  src="https://mdbcdn.b-cdn.net/img/new/avatars/2.webp"
                  class="rounded-circle"
                  height="35"
                  alt="Black and White Portrait of a Man"
                  loading="lazy"
                />
              </a>
              <ul
                class="dropdown-menu dropdown-menu-end drop-ul-user"
                aria-labelledby="navbarDropdownMenuAvatar"
              >
                <li>
                  <Link class="dropdown-item drop-a-user" to="profile">
                    My profile
                  </Link>
                </li>
                <li>
                  <Link class="dropdown-item drop-a-user" to="watchlist">
                    Watch list
                  </Link>
                </li>
                <li>
                  <Link class="dropdown-item drop-a-user" onClick={LogoutFun}>
                    Logout
                  </Link>
                </li>
              </ul>
            </div>
          )}
        </MDBCollapse>
      </MDBContainer>
      <Login
        display={displayLogin}
        noneLogin={noneLoginModel}
        isLoginIn={() => setisLogin(true)}
        flexLogin={() => setDisplayLogin("flex")}
      />
    </MDBNavbar>
  );
}
